// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"qY4Til5DR1xiDQ3fMtQRx"};